import { render, staticRenderFns } from "./IncidentForm.vue?vue&type=template&id=09949972&scoped=true"
import script from "./IncidentForm.vue?vue&type=script&lang=js"
export * from "./IncidentForm.vue?vue&type=script&lang=js"
import style0 from "./IncidentForm.vue?vue&type=style&index=0&id=09949972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09949972",
  null
  
)

export default component.exports